/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settingsnav_Searchplaceholder2Inputs */

const zh_settingsnav_searchplaceholder2 = /** @type {(inputs: Settingsnav_Searchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索设置...`)
};

const en_settingsnav_searchplaceholder2 = /** @type {(inputs: Settingsnav_Searchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search settings...`)
};

const es_settingsnav_searchplaceholder2 = /** @type {(inputs: Settingsnav_Searchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar configuración...`)
};

/**
* | output |
* | --- |
* | "Search settings..." |
*
* @param {Settingsnav_Searchplaceholder2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const settingsnav_searchplaceholder2 = /** @type {((inputs?: Settingsnav_Searchplaceholder2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsnav_Searchplaceholder2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_settingsnav_searchplaceholder2(inputs)
	if (locale === "en") return en_settingsnav_searchplaceholder2(inputs)
	return es_settingsnav_searchplaceholder2(inputs)
});
export { settingsnav_searchplaceholder2 as "settingsNav_searchPlaceholder" }